export default __webpack_public_path__ + "static/media/partner (4).e9daef64.png";